export const toggleEnabledPipelineName = (names: string[], name: string): string[] =>
  names.includes(name) ? names.filter((current) => current !== name) : [...names, name];
